import { render } from "./Prestador.vue?vue&type=template&id=0df406d2&scoped=true"
import script from "./Prestador.vue?vue&type=script&lang=js"
export * from "./Prestador.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=0df406d2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df406d2"]])

export default __exports__